// client/src/api/BillingApi.ts
import { axiosInstance } from "../helpers/request";
import type {
  CheckoutOperationView,
  CheckoutResult,
  BillingCatalog,
  RetryAllPaymentsResult,
  StreamPlan,
  SubscriptionListItem,
} from "../types/billing";

class BillingApi {
  getCatalog() {
    return axiosInstance.get<BillingCatalog>("/billing/catalog");
  }

  /** Buys a new streaming slot. Nothing is created until Stripe confirms. */
  createCheckout(plan: StreamPlan, requestKey: string) {
    return axiosInstance.post<{ url: string | null; operationId?: string }>(
      "/billing/checkout",
      { plan, requestKey },
    );
  }

  /** Self-healing checkout reconcile; the client polls it after Stripe returns. */
  reconcile(sessionId: string) {
    return axiosInstance.post<CheckoutResult>(
      "/billing/reconcile",
      { sessionId },
    );
  }

  getCheckoutOperation(operationId: string) {
    return axiosInstance.get<CheckoutOperationView>(
      `/billing/checkout/${operationId}`,
    );
  }

  retryCheckoutOperation(operationId: string) {
    return axiosInstance.post(`/billing/checkout/${operationId}/retry`);
  }

  listSubscriptions() {
    return axiosInstance.get<SubscriptionListItem[]>("/billing/subscriptions");
  }

  getPortalSession() {
    return axiosInstance.post<{ url: string | null; operationId?: string }>(
      "/billing/portal",
    );
  }

  retryAll() {
    return axiosInstance.post<RetryAllPaymentsResult>("/billing/retry-all");
  }
}

const billingApiInstance = new BillingApi();
export default billingApiInstance;
